module.exports = __webpack_public_path__ + "img/medMission_041022_F.b310ab1e.jpg";